import { getPaymentInfo } from '@jotta/grpc-connect-openapi/subscriptionQuery'

import { createConnectQuery } from './createConnectQuery'
import { authTransport } from './transport'

export const usePaymentInfo = createConnectQuery(getPaymentInfo, {
  transport: authTransport,
})
